import { cn } from "@wags/ui/ui-utils";
import { VercelImage } from "@wags/ui/vercel-image.tsx";
import WagsLogo from "@/assets/icons/wags-logo.svg";

export function DogPhoto({
    url,
    size,
    tone = "light",
    logo = "small",
    listingMedia = false,
}: {
    url: string | null | undefined;
    size: number;
    tone?: "light" | "dark";
    logo?: "small" | "large";
    listingMedia?: boolean;
}) {
    if (url) {
        return (
            <VercelImage
                src={url}
                listingMedia={listingMedia}
                alt=""
                width={size}
                height={size}
                className="size-full object-cover"
                videoMode="thumbnail"
            />
        );
    }
    return (
        <span
            className={cn(
                "flex size-full items-center justify-center",
                tone === "dark" && "pb-12",
            )}
        >
            <WagsLogo
                className={cn(
                    "w-auto",
                    logo === "large" ? "h-1/2" : "h-1/4",
                    tone === "dark"
                        ? "text-true-white/15"
                        : "text-doberman-black/10",
                )}
            />
        </span>
    );
}
